import { defineStore } from 'pinia';

export const useAlertStore = defineStore('alert', {
  state: () => ({
    visible: false,
    isLoading: false,
    title: 'Atenção',
    message: ''
  }),
  actions: {
    show(message, title = 'Atenção') {
      this.message = message;
      this.title = title;
      this.visible = true;
      this.isLoading = false;
    },
    loading(show = true) {
      this.visible = show;
      this.isLoading = show;
      this.message = '';
      this.title = '';
    },
    close() {
      this.visible = false;
      this.isLoading = false;
    }
  }
});

